import { BaseService } from '@flint/framework';

export default class DeleteSubscription extends BaseService {
  constructor() {
    super("DELETING_SUBSCRIPTION_DATA", 'DeleteSubscriptionStore', true);
  }

  handleEvent(eventName, ID) {
    return this.getClient('vetService').delete(`/admin-api/subscriptions/${ID}`);
  }
}